module.exports = __webpack_public_path__ + "img/shop_closed_nl.e8446edb.png";